/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForDefaultWorkloadCreation extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForDefaultWorkloadCreation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForDefaultWorkloadCreation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForDefaultWorkloadCreation>): BackgroundJobPayloadForDefaultWorkloadCreation {
        let obj = Object.assign(new BackgroundJobPayloadForDefaultWorkloadCreation(), model);
        BackgroundJobPayloadForDefaultWorkloadCreation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForDefaultWorkloadCreation>): BackgroundJobPayloadForDefaultWorkloadCreation {
        if (!model) return null;
        return BackgroundJobPayloadForDefaultWorkloadCreation.newInstance(<BackgroundJobPayloadForDefaultWorkloadCreation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForDefaultWorkloadCreation) {
        if (!obj) return;

        models.BackgroundJobPayloadForDefaultWorkloadCreation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForDefaultWorkloadCreation): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForDefaultWorkloadCreation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service account ID for which to create default workload
     */
    service_account_id: string;

}
